import React from 'react';
import { BehaviorSubject } from 'rxjs';
import { Notifications } from 'shared/models/api/models';

export type NotificationsState = {
    stateNotifications: Notifications,
    requireRefresh: boolean,
    loading: boolean
}

const initialState: NotificationsState = {
    stateNotifications: {} as Notifications,
    requireRefresh: true,
    loading: false
};

const notificationsStateSubject = new BehaviorSubject<NotificationsState>(initialState);

export const notificationsState = {
    subscribe: (setState: any) => notificationsStateSubject.subscribe(setState),

    setNotifications: (notifications: Notifications) => {
        var newState = notificationsStateSubject.getValue();
        newState.stateNotifications = notifications;
        notificationsStateSubject.next(newState);
    },

    setRequireRefresh: (refresh: boolean) => {
        var newState = notificationsStateSubject.getValue();
        newState.requireRefresh = refresh;
        notificationsStateSubject.next(newState);
    },

    setLoading: (loading: boolean) => {
        var newState = notificationsStateSubject.getValue();
        newState.loading = loading;
        notificationsStateSubject.next(newState);
    }
}
